import React, { useEffect, useRef } from "react";
import { Link } from "react-router-dom";
import { motion, useInView, useAnimation } from "framer-motion";
import { getCaseStudyHomePreview } from "../../../utils/caseStudyUtils";
import CaseStudyCardOverlay from "./caseStudyCardOverlay";

const CaseStudyRow = ({ casestudy, featured = false }) => {
  const { id, image } = casestudy;
  const { title } = getCaseStudyHomePreview(casestudy);
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true });
  const mainControls = useAnimation();

  useEffect(() => {
    if (isInView) {
      mainControls.start("visible");
    }
  }, [isInView, mainControls]);

  return (
    <div className={`slider-container${featured ? " featured" : ""}`}>
      <Link to={`/clients/${id}`} className={`slider${featured ? " featured" : ""}`}>
        <motion.img
          initial={{
            scale: 0,
          }}
          animate={{
            scale: 1,
          }}
          transition={{
            duration: 8,
            ease: "easeIn",
          }}
          ref={ref}
          src={image}
          alt={title}
        />
        <CaseStudyCardOverlay casestudy={casestudy} />
      </Link>
    </div>
  );
};

export default CaseStudyRow;
